export const flagEmojis = {
  "🤣": "Rolling on the floor laughing",
  "😁": "Beaming face with smiling eyes",
  "😅": "Grinning face with sweat",
  "😍": "Smiling face with heart eyes",
  "😎": "Smiling face with sunglasses",
  "😂": "Face with tears of joy",
  "😊": "Smiling face with smiling eyes",
  "😒": "Unamused face",
  "👌": "OK Hand",
  "😘": "Face blowing a kiss",
  "🎉": "Part popper",
  "👍": "Thumbs up",
  "🙌": "Raising Hands",
  "✌": "Victory Hand",
  "😋": "Face savouring food",
  "🥰": "Smiling face with hearts",
  "😴": "Sleeping face",
  "😭": "Loudly crying face",
  "🥱": "Yawning face",
  "🤭": "Face with hand over mouth",
  "🥳": "Partying face",
  "😇": "Smiling face with halo",
  "🤧": "Sneezing face",
  "🤞": "Crossed fingers",
  "👋": "Weaving hand",
  "🤝": "Handshake",
  "🙏": "Folded hands",
  "✨": "Sparkles",
  "🔥": "Fire",
  "❄": "Snowflake",
  "❤": "Red Heart",
  "💖": "Sparkling Heart",
  "🚗": "Car",
  "🚓": "Police Car",
  "🚕": "Taxi",
  "🛺": "Auto Rickshaw",
  "🚙": "Sport utility vehicle",
  "🚌": "Bus",
  "🚐": "Minibus",
  "🚎": "Trolley Bus",
  "🚑": "Ambulance",
  "🚒": "Fire Engine",
  "🚚": "Delivery van",
  "🚛": "Articulated Lorry",
  "🚜": "Tractor",
  "🚘": "oncoming car",
  "🚔": "oncoming police car",
  "🚖": "oncoming taxi",
  "🚍": "oncoming bus",
  "🦽": "Manual wheel chair",
  "🦼": "Motorized wheel chair",
  "🛹": "Skateboard",
  "🚲": "Bicycle",
  "🛴": "Kick Scooter",
  "🛵": "Motor Scooter",
  "🏍": "Motorcycle",
  "🏎": "Racing car",
  "🚄": "High-speed train",
  "🚅": "Bullet train",
  "🚈": "Light rail",
  "🚝": "Monorail",
  "🚞": "Mountain railway",
  "🚃": "Railway Carriage",
  "🚋": "Tram Car",
  "🚆": "Train",
  "🚇": "Metro",
  "🚠": "Mountain cableway",
  "🚂": "Locomotive",
  "🛩": "Small Aeroplane",
  "🪂": "Parachute",
  "✈": "Aeroplane",
  "💺": "Seat",
  "🚁": "Helicopter",
  "🚀": "Rocket",
  "🛸": "Flying Saucer",
  "🛰": "Satellite",
  "⛵": "Sailing Boat",
  "🚤": "Speed Boat",
  "⛴": "Ferry",
  "🚢": "Ship",
  "🛳": "Passenger Ship",
};
